module.exports = __webpack_public_path__ + "img/success.01ddc00b.gif";